import html2Element from "@/utils/html2Element.js";
import noScroll from "@/utils/noScroll.js";

const popupsStack = [];
let currentPopup = null;

export default function showPopup(content, options) {
    const control = {};
    
    popupsStack.push({
        content: content,
        options: options || {},
        control: control
    });

    updateStack();

    return control;
}

function updateStack() {
    if (currentPopup || popupsStack.length < 1) {
        return;
    }

    currentPopup = popupsStack.shift();

    const content = currentPopup.content;
    const options = currentPopup.options;
    const template = options.template || `
        <div class="popup-overlay">
            <div class="popup-window">
                <button type="button" class="popup-close-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="M7.172 14.242 10 11.414l2.828 2.828 1.414-1.414L11.414 10l2.828-2.828-1.414-1.414L10 8.586 7.172 5.758 5.758 7.172 8.586 10l-2.828 2.828 1.414 1.414Z"/><path fill="currentColor" d="M10 20c5.514 0 10-4.486 10-10S15.514 0 10 0 0 4.486 0 10s4.486 10 10 10Zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8Z"/></svg>
                </button>
                <div class="popup-content"></div>
            </div>
        </div>
    `;

    let popupElement = html2Element(template);
    const popupWindow = popupElement.querySelector('.popup-window');
    const popupCloseButton = popupElement.querySelector('.popup-close-button');
    const popupContent = popupElement.querySelector('.popup-content');
    
    if (options.rootClass) {
        if (Array.isArray(options.rootClass)) {
            options.rootClass.forEach(c => popupElement.classList.add(c));
        } else if (typeof options.rootClass === 'string' || options.rootClass instanceof String) {
            popupElement.classList.add(options.rootClass);
        }
    }

    if (typeof content === 'string' || content instanceof String) {
        popupContent.innerHTML = content;
    } else if (content instanceof HTMLElement) {
        popupContent.appendChild(content);
    } else {
        popupElement.remove();
        updateStack();
    }

    popupElement.addEventListener("click", close);
    popupCloseButton.addEventListener("click", close);
    popupWindow.addEventListener("click", function (event) {
        event.stopPropagation();
        //event.preventDefault();
    });

    setTimeout(function () {
        if (popupElement) {
            popupElement.classList.add("visible");
        }
        noScroll.hideScroll();
    }, 10);

    function close() {
        currentPopup = null;
        if (popupElement) {
            popupElement.addEventListener("transitionend", function(event) {
                if (popupElement) {
                    if (options.keepContentOnClose) {
                        document.body.appendChild(content);
                    }

                    popupElement.remove();
                    popupElement = null;
                    noScroll.showScroll();
                }
            });

            popupElement.classList.remove("visible");
        }
        
        updateStack();
    }

    currentPopup.control.close = close;

    document.body.appendChild(popupElement);
}
